import {
  ApiDeleteMyWishlistRequestedAction,
  apiDeleteMyWishlistFailed,
  apiDeleteMyWishlistSucceeded
} from '@spa/lib/store/api/wishlists/deleteMyWishlistApi';
import { call, put } from 'typed-redux-saga';
import { WishlistError } from '@spa/components/wishlist/wishlistTypes';
import deleteMyWishlistAction from '@spa/lib/actions/wishlists/deleteMyWishlistAction';
import logger from '@spa/lib/logger';

function* deleteMyWishlistApiSaga({
  payload: { actionId: requestedActionId, parentActionId, id }
}: ApiDeleteMyWishlistRequestedAction): Generator {
  try {
    const result = yield* call(deleteMyWishlistAction, 'deleteMyWishlistAction', id);

    if (result.__typename === 'DeleteMyWishlistSucceededResult') {
      yield* put(apiDeleteMyWishlistSucceeded({ parentActionId, requestedActionId }));
    } else {
      yield* put(
        apiDeleteMyWishlistFailed({ error: result.error, parentActionId, requestedActionId })
      );
    }
  } catch (e) {
    logger.error(e, 'Error deleting my wishlist');

    yield* put(
      apiDeleteMyWishlistFailed({
        error: WishlistError.UNKNOWN_ERROR,
        parentActionId,
        requestedActionId
      })
    );
  }
}

export default deleteMyWishlistApiSaga;
